/**
 *
 */

var Anchor = (function($) {
  function initAnchor() {
    $(document).on("click", 'a[href^="#"]', function(e) {
      var targetId = $(this).attr("href");

      // evitar casos tipo href="#"
      if (targetId.length <= 1) return;

      var $target = $(targetId);

      if ($target.length) {
        e.preventDefault();

        var offset = 120; // ajusta si tienes header sticky
        var targetPosition = $target.offset().top - offset;

        $("html, body").animate(
          {
            scrollTop: targetPosition
          },
          700
        );
      }
    });
  }

  function init() {
    if (!$(".main").length) return;
    initAnchor();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Anchor.init);
